import React, { useState } from "react";
import { Modal } from "antd";
import styled from "@emotion/styled";

import LogoImg from "../../assets/images/sonkthai-Logo.png";
import WinkL from "../../assets/images/wink-L.png";
import WinkM from "../../assets/images/wink-M.png";
import WinkS from "../../assets/images/wink-S.png";
import ShareIcon from "../../assets/icons/share.svg";

import exportAsImage from "../../utils/shareSocial";

const RewardModal = ({ onClose, visible, personalId, week, reward = {} }) => {
  const [disableShareBtn, setDisableShareBtn] = useState(false);
  return (
    <StyledModal
      closable
      footer={null}
      visible={visible}
      onCancel={onClose}
      width={320}
    >
      <Wink1 src={WinkL} />
      <Wink2 src={WinkM} />
      <Wink3 src={WinkS} />
      <RewardImg
        src={
          reward.image && require(`../../assets/images/badges/${reward.image}`)
        }
      />
      <Wink4 src={WinkL} />
      <Wink5 src={WinkM} />
      <Wink6 src={WinkS} />
      <Container>
        <Topic>แชร์บน Facebook</Topic>
        <Remark>
          เลขประจำตัว {personalId}
          <br />
          ท่านถึงเป้าหมาย <span className="bold"> {reward.category}</span>
          <br />
          สัปดาห์ที่ {week}
          <br />
          {reward.levelInfo}
        </Remark>
        <SonkthaiImg src={LogoImg} />
        <Conclusion>ขอมอบ{reward.desc}</Conclusion>
        <ShareBtn
          onClick={() => !disableShareBtn && exportAsImage(setDisableShareBtn)}
          disabled={disableShareBtn}
        >
          <img src={ShareIcon} />
          แชร์
        </ShareBtn>
        <Cancel onClick={onClose}>ยกเลิก</Cancel>
      </Container>
    </StyledModal>
  );
};

export default RewardModal;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  background: #fff;
  padding-top: 100px;
  margin-top: -80px;
  width: 320px;
  margin-left: -32px;
  border-top-left-radius: 50% 35px;
  border-top-right-radius: 50% 35px;
`;

const Topic = styled.h5`
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #058459;
  margin-bottom: 4px;
`;
const Remark = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #4b5768;
  margin-bottom: 16px;

  > span.bold {
    font-weight: 700;
  }
`;
const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    background: linear-gradient(
        179.7deg,
        rgba(255, 219, 165, 0.6) -2.19%,
        rgba(249, 249, 249, 0.6) 48.23%
      ),
      #ffffff;

    .ant-modal-body {
      padding: 36px 32px;
      text-align: center;
    }
  }
`;
const RewardImg = styled.img`
  margin-bottom: 27px;
  margin-top: 20px;
  width: 186.56px;
  height: 168px;
`;
const SonkthaiImg = styled.img`
  height: 54px;
  width: 122px;
  margin-bottom: 16px;
`;
const Conclusion = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #16af7b;
`;
const Wink1 = styled.img`
  position: absolute;
  top: 68px;
  left: 76px;
`;
const Wink2 = styled.img`
  position: absolute;
  top: 85px;
  left: 59px;
`;
const Wink3 = styled.img`
  position: absolute;
  top: 58px;
  left: 78px;
`;
const Wink4 = styled.img`
  position: absolute;
  top: 87px;
  right: 65px;
`;
const Wink5 = styled.img`
  position: absolute;
  top: 78px;
  right: 52px;
`;
const Wink6 = styled.img`
  position: absolute;
  top: 113px;
  right: 60px;
`;
const ShareBtn = styled.div`
  padding: 14px 32px;
  width: 206px;
  height: 51px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 19px;
  line-height: 23px;
  letter-spacing: -0.02em;
  display: inline-block;
  margin-top: 14px;

  img {
    margin-right: 8px;
  }

  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }

  background: ${(props) => (props.disabled ? "#d0d5dd" : "#16af7b")};
  color: ${(props) => (props.disabled ? "#64748b" : "#ffffff")};
`;
const Cancel = styled.div`
  margin-top: 16px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  text-decoration-line: underline;
  color: #058459;

  &:hover {
    cursor: pointer;
  }
`;
